import localforage from 'localforage';
import { ApartmentCompare } from '../type/ApartmentCompare.type';
import { v4 as uuidv4 } from 'uuid';
import { useAppStateLoadingCountStore } from '../../../common/store/AppStateStore.zustand';

const apartmentCompareStore = localforage.createInstance({
  name: 'honeymoonsalad',
  storeName: 'apartmentCompareStore',
});

export const useApartmentCompareStore = () => {
  const { addCount, minusCount } = useAppStateLoadingCountStore();

  const exportApartmentCompareStore = async () => {
    const keys = await apartmentCompareStore.keys();
    const entries = await Promise.all(
      keys.map(async (key) => ({ key, value: await apartmentCompareStore.getItem(key) })),
    );
    return entries;
  };

  const importApartmentCompareStore = async (entries: { key: string; value: unknown }[]) => {
    await apartmentCompareStore.clear();
    await Promise.all(entries.map(({ key, value }) => apartmentCompareStore.setItem(key, value)));
    return true;
  };

  const clearApartmentCompareStore = async () => {
    await apartmentCompareStore.clear();
    return true;
  };

  const insertApartmentCompareToStore = async (apartmentCompare: ApartmentCompare) => {
    addCount();
    const id = apartmentCompare.id ? apartmentCompare.id : uuidv4().toString();
    apartmentCompare.id = id;
    await apartmentCompareStore.setItem(id, apartmentCompare);
    minusCount();
    return { data: id };
  };

  const getApartmentCompareListFromStore = async () => {
    addCount();
    const keys = await apartmentCompareStore.keys();
    const list = await Promise.all(keys.map((key) => apartmentCompareStore.getItem<ApartmentCompare>(key)));
    minusCount();
    return { data: list as ApartmentCompare[] };
  };

  const updateApartmentCompareInStore = async (apartmentCompare: ApartmentCompare) => {
    addCount();
    await apartmentCompareStore.setItem(apartmentCompare.id, apartmentCompare);
    minusCount();
    return { data: apartmentCompare.id };
  };

  const deleteApartmentCompareAtStore = async (id: string) => {
    addCount();
    const item = await apartmentCompareStore.getItem<ApartmentCompare>(id);
    await apartmentCompareStore.removeItem(id);
    minusCount();
    return { data: item };
  };

  return {
    apartmentCompareStore,
    exportApartmentCompareStore,
    importApartmentCompareStore,
    clearApartmentCompareStore,
    insertApartmentCompareToStore,
    getApartmentCompareListFromStore,
    updateApartmentCompareInStore,
    deleteApartmentCompareAtStore,
  };
};
